<script>
  import { _ } from "svelte-i18n";
</script>

<div class="title">
  <h2>{$_("lesson-m9UPL.h2-0")}</h2>
</div>
<hr />
<div class="text">
  <p>
    {@html $_("lesson-m9UPL.p-0")}
  </p>
  <p>
    {@html $_("lesson-m9UPL.p-1")}
  </p>
  <ol>
    <li>{@html $_("lesson-m9UPL.li-0")}</li>
    <li>{@html $_("lesson-m9UPL.li-1")}</li>
    <li>{@html $_("lesson-m9UPL.li-2")}</li>
  </ol>
  <p>
    {@html $_("lesson-m9UPL.p-2")}
  </p>
  <div align="center"><img width="40%" src="/img/GraphToMatrix.png" alt="A snapshot of the interface of the tool Graph to Matrix"></div>
</div>

<style>
  .title h2 {
    background: -webkit-linear-gradient(90deg, #1a91bc, #2eb6e8);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  hr {
    border: 1px solid white;
    border-top: 1px solid #ddd;
    margin: 20px auto;
  }
</style>
